import React from "react";

const Stat = () => {
  return (
    <div className="container mx-auto px-6 space-y-8">
      {/* Views and Users Stats Section */}
      <div className="flex justify-center">
        <div className="flex flex-col md:flex-row gap-4  p-4 rounded-lg max-w-2xl">
          <div className="md:w-1/2">
            <div className="stat p-4 bg-[#19233A] rounded-lg shadow-md h-full">
              <div className="stat-figure text-primary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  className="inline-block w-8 h-8 stroke-current"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  ></path>
                </svg>
              </div>
              <div className="stat-title text-white">Website Views</div>
              <div className="stat-value text-primary">2.6M</div>
              <div className="stat-desc text-gray-300">
                17% more than last month
              </div>
            </div>
          </div>

          <div className="md:w-1/2">
            <div className="stat p-4 bg-[#19233A] rounded-lg shadow-md h-full">
              <div className="stat-figure text-primary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  className="inline-block w-8 h-8 stroke-current"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                  ></path>
                </svg>
              </div>
              <div className="stat-title text-white">New Users</div>
              <div className="stat-value text-primary">10,200</div>
              <div className="stat-desc text-gray-300">↗︎ 250 (22%)</div>
            </div>
          </div>
        </div>
      </div>

      {/* TrustScore Section */}
      <div className="flex justify-center max-w-xl mx-auto">
        <div className="bg-[#0f172a] p-8 rounded-lg w-full">
          <a
            href="https://www.scamadviser.com/check-website/hydraflasher.com"
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer flex flex-col items-center"
          >
            <div className="relative w-80 h-48">
              <svg viewBox="0 0 200 100" className="w-full">
                {/* Background arc (dark gray) */}
                <path
                  d="M 20,100 A 80,80 0 0,1 180,100"
                  stroke="#1e293b"
                  strokeWidth="20"
                  strokeLinecap="round"
                  fill="none"
                />
                {/* Green arc (86% of the way) */}
                <path
                  d="M 20,100 A 80,80 0 0,1 150,40"
                  stroke="#22c55e"
                  strokeWidth="20"
                  strokeLinecap="round"
                  fill="none"
                />
                {/* End cap (black) */}
                <circle cx="150" cy="40" r="10" fill="#0f172a" />
              </svg>

              {/* Score text - centered in the gauge */}
              <div className="absolute inset-0 flex flex-col items-center justify-center space-y-1 mt-10">
                <h3 className="text-2xl font-bold text-white">Trustscore</h3>
                <p className="text-4xl text-white font-light">
                  <span className="text-green-400 font-bold">86</span> / 100
                </p>
              </div>
            </div>

            <div className="text-center flex flex-col items-center gap-4">
              <a
                href="https://www.scamadviser.com/articles/scamadviser-algorithm-explainer"
                target="_blank"
                rel="noopener noreferrer"
                className="text-red-500 font-bold text-xl hover:underline mb-2"
              >
                What is this?
              </a>
              <a
                href="https://www.scamadviser.com/check-website/hydraflasher.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-200 shadow"
              >
                Check Us on Scam Adviser
              </a>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Stat;
